class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = document.querySelector('.cart-notification-overlay');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.overlay.addEventListener('click', this.close.bind(this));

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.style.display = 'block';
    this.notification.classList.add('animate', 'active');
    this.overlay.classList.remove('tw-hidden');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    this.autoCloseTimeout = setTimeout(this.close.bind(this), 3000);
  }

  close() {
    this.style.display = 'none';
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.overlay.classList.add('tw-hidden');
    removeTrapFocus(this.activeElement);
    clearTimeout(this.autoCloseTimeout);
  }



  
  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }

    if (!this.notification.contains(target)) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
